import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-routes',
  templateUrl: './add-routes.component.html',
  styleUrls: ['./add-routes.component.css']
})
export class AddRoutesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
